import { defineField, defineType } from "sanity";

export const appContentTypeDoc = defineType({
  type: "document",
  name: "appContentType",
  title: "App Content",
  fields: [
    // insurance cards, list of key + image
    defineField({
      name: "insuranceCards",
      type: "array",
      title: "Insurance Cards",
      of: [
        {
          type: "object",
          title: "Insurance Card",
          fields: [
            defineField({
              name: "title",
              type: "string",
              title: "Name",
              description: "Name"
            }),
            defineField({
              name: "insuranceNames",
              type: "array",
              title: "Insurance Names",
              of: [
                {
                  type: "string",
                  title: "Insurance Name",
                  description: "Insurance Name"
                }
              ]
            }),
            defineField({
              name: "image",
              type: "image",
              title: "Image",
              description: "Image of the insurance card"
            })
          ]
        }
      ]
    })
  ]
});
